// Which ⋮ menu actions a design card offers. Edit no longer depends on the design source, matching the platform (PAD-32396).

export type DesignMenuAction = "preview" | "edit" | "download";

export interface DesignMenuHandlers {
  readonly onEdit?: unknown;
  readonly onDownload?: unknown;
}

export const getDesignMenuActions = (handlers: DesignMenuHandlers): DesignMenuAction[] => [
  "preview",
  ...(handlers.onEdit ? (["edit"] as const) : []),
  ...(handlers.onDownload ? (["download"] as const) : []),
];
